import { useFollowingIdReference } from './useFollowingIdReference';

export function useIsFollowing(sonarObjectId: number): boolean {
	return useFollowingIdReference()?.[ sonarObjectId ] ?? false;
}
